import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {UserStateProvider} from "../user-state/user-state";

/*
  Generated class for the ApiStepCounterProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiStepCounterProvider {

  constructor(public api: ApiProvider, public iab: InAppBrowser, protected userState: UserStateProvider) {
  }

  createSession(type: string) {
    var me = this;
    return new Promise((resolve, reject) => {
      me.api.callGet('/oauth/' + type + "/authorize").subscribe((res:any) => {
        if (res.status) {
          resolve();
          return ;
        }
        if (res.url) {
          let browser = me.iab.create(res.url, "_system");
          return ;
        }
        if (!res.status) {
          reject();
        }
      }, (err: any) => {
        reject();
      })
    });
  }

  syncSteps(date: string) {
    var me = this;
    return new Promise((resolve, reject) => {
      me.api.callGet('/users/'+me.userState.user.id+'/sync', {date: date}).subscribe((res:any) => {
        resolve(res);
      }, (err: any) => {
        reject();
      })
    });
  }

  syncRangeSteps(date: string, endDate: string) {
    var me = this;
    return new Promise((resolve, reject) => {
      me.api.callGet('/users/'+me.userState.user.id+'/sync', {date: date, endDate: endDate}).subscribe((res:any) => {
        resolve(res);
      }, (err: any) => {
        reject();
      })
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-step-counter/api-step-counter.ts